/**
 * Derives shipping integration state from the integrations slice.
 *
 * The backend returns { shipper_hq_enabled: boolean } from the shipper_hq_check mode.
 *
 * We model an explicit "unknown" state while integrations are still loading
 * to avoid accidentally routing ShipperHQ portals into ShipEngine endpoints.
 *
 * @param {object} integrations - Integrations state from Redux
 * @returns {{ isShipperHQ: boolean, isShipEngine: boolean, isFulfillmentIntegrationUnknown: boolean }}
 */
export const useShipperHQCheck = integrations => {
  if (integrations?.status !== 'succeeded') {
    return {
      isShipperHQ: false,
      isShipEngine: false,
      isFulfillmentIntegrationUnknown: true
    }
  }

  const shipperHQEnabled = integrations?.data?.shipper_hq_enabled

  return {
    isShipperHQ: shipperHQEnabled === true,
    isShipEngine: shipperHQEnabled === false,
    isFulfillmentIntegrationUnknown: typeof shipperHQEnabled !== 'boolean'
  }
}
